module.exports = __webpack_public_path__ + "static/img/icon2.d33e492c.png";